export default {
  dataIterator: {
    rowsPerPageText: '每页记录数：',
    rowsPerPageAll: '全部',
    pageText: '{0}-{1} 共 {2} 条',
    noResultsText: '没有找到匹配记录',
    nextPage: '下一页',
    prevPage: '上一页'
  },
  dataTable: {
    rowsPerPageText: '每页行数：'
  },
  noDataText: '暫無數據',
  carousel: {
    prev: '上一個视觉',
    next: '下一個视觉'
  }
}
